import React from "react";
import { observer } from "mobx-react";
import { Overlay } from "main/overlay/Overlay";
import { overlayStore } from "main/overlay/_stores/overlayStore";

export const OverlayObserver = observer(() => {
    return <Overlay option={overlayStore.option} />;
});
